module.exports = __webpack_public_path__ + "img/vocus-logo2.626acba1.png";